import React from 'react';
import TabsLink from '../../../tabs/TabsLink';
import { useSelector } from 'react-redux';

const Tabs = () => {
  const roles = useSelector(state => state?.session?.user?.roles?.map((role) => role.id) || [])

  return (
    <div className='relative overflow-hidden w-full h-full flex items-end'>
      <TabsLink
        id='my-surveys'
        items={[
          {
            id: 'assigned',
            name: 'Assigned',
            path: '/dashboard/data-entry/my-surveys',
            permission: true,
            end: true
          },
          {
            id: 'about-me',
            name: 'About me',
            path: '/dashboard/data-entry/my-surveys/about-me',
            permission: true,
            end: true
          },
          {
            id: 'about-my-classes',
            name: 'About my classes',
            path: '/dashboard/data-entry/my-surveys/about-my-classes',
            permission: roles.includes('Teacher'),
            end: true
          }
        ]}
      />
    </div>
  );
};

export default Tabs;
